// src/hooks/usePopover.tsx
import { useDisclosure, useMultiStyleConfig } from "@chakra-ui/react";
import { useBreakpointValue } from "@stockx/ui-responsive";
var usePopover = (variant) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { size, isMobile } = useBreakpointValue();
  const placement = "top";
  const {
    popoverCloseButton,
    popoverBody,
    popoverArrow,
    popoverContent,
    popoverHeader,
    popoverFooter
  } = useMultiStyleConfig("Popover", {
    size,
    variant
  });
  return {
    isOpen,
    onOpen,
    onClose,
    size,
    placement,
    isMobile,
    sx: {
      popoverCloseButton,
      popoverBody,
      popoverArrow,
      popoverContent,
      popoverHeader,
      popoverFooter
    }
  };
};
var usePopover_default = usePopover;

export {
  usePopover_default
};
